import React from "react";
import Common from "../based/Common";
import SellerTransferHistoryManagement from "../credit/seller/SellerTransferHistoryManagement";
import AdminTransferHistoryManagement from "../credit/admin/AdminTransferHistoryManagement";

export default function TransferManagement(props) {
    return <React.Fragment>{!Common.IsAdmin() ? <SellerTransferHistoryManagement {...props} /> : <AdminTransferHistoryManagement {...props} />}</React.Fragment>;
}
